import { IndicationUnit } from "@shared/components/Metrics/IndicationUnit";
import { Text } from "@solomon-labs/design/components/ui";
import React from "react";

import { EmberBlocksAnimation } from "./EmberBlocksAnimation";

/**
 * @version 1.0.0
 * @published 2026-04-08
 * @history
 *   1.0.0 — Initial publish from prototype/pages/Perks/PerksPage.tsx. Left-side
 *           hero block for the Perks landing page — animated ember blocks +
 *           display headline + Season indicator.
 */
export function PerksHero(): React.ReactElement {
    return (
        <div className="flex flex-col items-center gap-6">
            {/* Animated ember blocks — drops into pyramid, reassembles into square */}
            <EmberBlocksAnimation />

            {/* Display headline */}
            <Text
                variant="hero"
                render={<p />}
                className="text-foreground-base text-center"
            >
                Solomon
                <br />
                <span className="text-accent">Standard</span>
            </Text>

            {/* Season indicator */}
            <div className="flex gap-2 items-center">
                <IndicationUnit />
                {/* FLAG(text-sweep): font-numeric text-base no tabular-nums with custom tracking-[0.24px] — needs product decision */}
                <span className="font-numeric text-base leading-none text-foreground-base tracking-[0.24px]">
                    Season 1
                </span>
            </div>
        </div>
    );
}
